import React, { useEffect } from 'react';

import { NodeStatesContext, useNodeStates } from '../EditorNodeStates';
import { FileBuffer, FileBufferContext } from '../FileBuffer';
import { NodePerformanceContext } from '../Performance';
import ReactNodeViewPortalsProvider from '../ReactNodeViewPortals';
import { RequestContext } from '../RequestProvider';
import { Storage, StorageContext } from '../Storage';
import { NewEditor } from './Editor';
import { NewEditorProps } from './types';

const fileBuffer = new FileBuffer();
const storage = new Storage();

const EditorContextProvider: React.FC<NewEditorProps> = (props) => {
  const {
    setNodePerformance,
    getRequest,
    getNodePerformance,
    useConvertFile,
    postRequest,
    enabledConvertibleImport,
  } = props;
  const { setNodeState, getNodeState } = useNodeStates();

  useEffect(() => {
    return () => {
      fileBuffer.clear();
    };
  }, []);

  return (
    <RequestContext.Provider
      value={{
        getRequest,
        postRequest,
        useConvertFile,
        enabledConvertibleImport,
      }}>
      <StorageContext.Provider value={{ storage }}>
        <FileBufferContext.Provider value={{ fileBuffer }}>
          <NodeStatesContext.Provider value={{ setNodeState, getNodeState }}>
            <NodePerformanceContext.Provider value={{ setNodePerformance, getNodePerformance }}>
              <ReactNodeViewPortalsProvider>
                <NewEditor {...props} />
              </ReactNodeViewPortalsProvider>
            </NodePerformanceContext.Provider>
          </NodeStatesContext.Provider>
        </FileBufferContext.Provider>
      </StorageContext.Provider>
    </RequestContext.Provider>
  );
};

export default EditorContextProvider;
